<template>
  <v-container fluid grid-list-md align-center pa-0>
    <ComponentAdminReportNursery72 />
  </v-container>
</template>

<script>
import ComponentAdminReportNursery72 from "@/components/admin/ComponentAdminReportNursery72";
export default {
  components: {
    ComponentAdminReportNursery72,
  },
};
</script>

<style scoped></style>
